import { FC } from 'react';

export const EmptyBlog: FC = () => (
    <div className="rounded-2xl border-dashed bg-card py-12">
        <h2 className="mb-2 text-xl font-semibold">Поки що статей немає</h2>
        <p className="max-w-lg text-sm text-muted-foreground">
            Ми готуємо гайди, новини та поради для колекціонерів TCG-карток.
            Повертайтесь пізніше.
        </p>
    </div>
);
